.tile-frame {
  /* position: relative; */
  display: grid;
  grid-template: 'stack' 1fr / 1fr;
  inline-size: 100%;
  block-size: 100%;
  anchor-name: --tile-frame;
  anchor-scope: all;
  /* container-type: inline-size; */

  overflow: hidden;
  :fullscreen & {
    overflow: hidden;
  }
}

.tile-frame.is-measured {
  content-visibility: visible;
}

.tile-content {
  display: grid;
  /* min-inline-size: 0; */
  /* min-block-size: 0; */
  contain-intrinsic-size: auto 10rem;
  /* overflow: auto; */
  :fullscreen & {
    overflow: auto;
  }
}

.tile-frame {
  &::after {
    position-anchor: --tile-frame;
    position: absolute;
    width: anchor-size(inline);
    height: anchor-size(block);
    display: none;
    content: '';
    border: 0.1rem dashed var(--mantine-color-dark-4);
    border-radius: var(--mantine-radius-md);
  }
  &.is-resizing {
    .tile-content {
      content-visibility: hidden;
    }
    &::after {
      display: block;
    }
  }
}

.tile-actions {
  position-anchor: --tile-frame;
  position: absolute;
  top: anchor(top);
  right: anchor(right);
  z-index: 100;
  display: flex;
  flex-flow: column nowrap;
  gap: var(--mantine-spacing-2xs);
  padding: 0.25rem;
  pointer-events: none;
  background: alpha(var(--mantine-color-dark-6), 0.5);
  border-radius: var(--mantine-radius-sm);
  opacity: 0;
  backdrop-filter: blur(4px);
  translate: calc(100%) 0%;
  transition: opacity 150ms ease;
  :fullscreen & {
    top: unset;
    bottom: anchor(bottom);
    flex-flow: row nowrap;
    translate: 0 0;
  }
}

/* Actions are visible whenever the tile is focused, hovered, or fullscreen
   — the last keeps them reachable so the user can always exit fullscreen.
   The fullscreen branch is class-driven from React rather than via
   `@container style()` so it works on Firefox. */
.tile-frame:hover .tile-actions,
.tile-frame:focus-within .tile-actions,
.tile-frame:fullscreen .tile-actions {
  pointer-events: auto;
  opacity: 1;
}

.tile-frame:fullscreen {
  width: 100%;
  height: 100%;
  padding: var(--mantine-spacing-xl);
  overflow: auto;
  background: var(--mantine-color-dark-9);
}
